import {
  Bot,
  Braces,
  CreditCard,
  Home,
  KeyRound,
  ShieldCheck,
  SquareAsterisk,
  User,
  Users,
} from 'lucide-react'
import { useLocation } from 'react-router'
import { AppBreadcrumbs } from '@/components/layout/breadcrumbs/app/app-breadcrumbs'
import { CompanySwitcher } from '@/components/layout/breadcrumbs/company-switcher'
import { DatabaseBreadcrumbs } from '@/components/layout/breadcrumbs/database/database-breadcrumbs'
import { LoadBalancerBreadcrumbs } from '@/components/layout/breadcrumbs/load-balancer/load-balancer-breadcrumbs'
import { ObjectStorageBreadcrumbs } from '@/components/layout/breadcrumbs/object-storage/object-storage-breadcrumbs'
import { ProjectBreadcrumb } from '@/components/layout/breadcrumbs/project/project-breadcrumb'
import { StaticSiteBreadcrumbs } from '@/components/layout/breadcrumbs/static-site/static-site-breadcrumbs'
import { TemplatesBreadcrumbs } from '@/components/layout/breadcrumbs/templates/templates-breadcrumbs'
import { WebhookBreadcrumbs } from '@/components/layout/breadcrumbs/webhook/webhook-breadcrumbs'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'

export const Breadcrumbs = () => {
  const location = useLocation()
  const pathname = location.pathname

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <CompanySwitcher />
        </BreadcrumbItem>
        {pathname.includes('/project/') ? null : <BreadcrumbSeparator />}
        {pathname === '/' ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <Home className="size-3.5" />
              <span>Home</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/my-account') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <User className="size-3.5" />
              <span>My account</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/billing') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <CreditCard className="size-3.5" />
              <span>Billing</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/api-keys') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <KeyRound className="size-3.5" />
              <span>API keys</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/registry-credentials') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <SquareAsterisk className="size-3.5" />
              <span>Registry credentials</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/global-variables') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <Braces className="size-3.5" />
              <span>Global variables</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/user-management') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <Users className="size-3.5" />
              <span>User management</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/single-sign-on') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <ShieldCheck className="size-3.5" />
              <span>Single sign-on</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        {pathname.startsWith('/help/ai-support') ? (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2 px-2 font-medium">
              <Bot className="size-3.5" />
              <span>AI support</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        ) : null}
        <AppBreadcrumbs />
        <DatabaseBreadcrumbs />
        <WebhookBreadcrumbs />
        <StaticSiteBreadcrumbs />
        <ObjectStorageBreadcrumbs />
        <LoadBalancerBreadcrumbs />
        <TemplatesBreadcrumbs />
        <ProjectBreadcrumb />
      </BreadcrumbList>
    </Breadcrumb>
  )
}
